export default __webpack_public_path__ + "static/media/policehelp.7b6f272a.jpg";